// extracted by mini-css-extract-plugin
export default {"wrapper":"ntFwRJ5SpkWjAkDeCWwz","warning":"I9AAf7xfHmDa6yTQ7eC0","danger":"BWJRpWjTN3QMfmKVRRC5","info":"NKmSviElTbsQWYRKa8Aw"};